/**
 * Stops mouse-wheel from changing <input type="number"> while that field is focused.
 * Uses capture + non-passive so preventDefault works. Page scroll is unaffected when the field is not focused.
 */
export function installNumberInputWheelGuard() {
  if (typeof document === 'undefined') return;
  const onWheel = (e) => {
    const t = e.target;
    if (
      t instanceof HTMLInputElement
      && t.type === 'number'
      && document.activeElement === t
      && !t.disabled
      && !t.readOnly
    ) {
      e.preventDefault();
    }
  };
  document.addEventListener('wheel', onWheel, { passive: false, capture: true });
}
